import { LocalDate, nativeJs } from '@js-joda/core';
import { chain } from 'lodash';

import { MedicalDataAccessAuthorization, MedicalTreatmentConsent } from '@dreryk/egabinet-patient-frontend-api';

import { MedicalConsentAndAuthorizationPrintBean } from './MedicalConsentAndAuthorizationsPrintModal';
const isToday = (date: Date): boolean => LocalDate.from(nativeJs(new Date(date))).equals(LocalDate.now());

export const createInitialFormValues = (
   medicalDataAccessAuthorization: MedicalDataAccessAuthorization[],
   medicalConsent?: MedicalTreatmentConsent | null
): MedicalConsentAndAuthorizationPrintBean => {
   const patientConsentToPrint = medicalConsent?.enterDate ? isToday(medicalConsent?.enterDate) : false;

   const confirmedAuthorizationsToPrint = chain(medicalDataAccessAuthorization)
      .map((authorization: MedicalDataAccessAuthorization) => {
         return authorization.enterDate && isToday(authorization.enterDate) ? authorization.id.toString() : null;
      })
      .compact()
      .value();

   return {
      patientConsentToPrint: patientConsentToPrint,
      confirmedAuthorizationsToPrint: confirmedAuthorizationsToPrint,
   };
};
